import React from 'react'

export const Footer = () => {
    return (
    <footer>
        <h4>  by Daniel and Pinar 2021 </h4>
    </footer>
      )
} 